'use strict';

import {communicationSubjectModel} from "../../models/communicationsubjectmodel.js";

export class IrregularitiesNewDialogCtrl
{
	ctrl = this;
	
	$scope;
	
	$mdDialog;
	
	jsDataService;
	
	constructor($scope, $mdDialog, jsDataService){
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.$scope = $scope;
		this.$scope.isSearch = true;
		this.$scope.searchString = '';
		this.$scope.projects = [];
		this.$scope.selectedProject = null;
		
		$scope.$watch("searchString", (nval, oval) => {
			if(typeof(nval) !== 'undefined' && nval !== ''){
				this.getProjects();
			}
			else{
				this.resetResults();
			}
		});
	}

	getProjects(){
		if(this.jsDataService.get('cfgProjectsUrl')){
			this.$scope.$root.basicHttpConfigProcess({
				url: this.jsDataService.get('cfgProjectsUrl'),
				method: 'GET',
				params: {
					query: this.$scope.searchString
				}
			}).then((response) => {
				if(response.data.success){
					this.$scope.projects = response.data.data;
				}
			}, () => {});
		}
	}
	
	resetResults(){
		this.$scope.projects = [];
	}
	
	hasResults(){
		return this.$scope.projects.length > 0;
	}
	
	selectProject(project){
		this.$scope.selectedProject = project;
		this.$scope.searchString = '';
	}
	
	close(){
		this.$mdDialog.cancel();
	}
	
	save(){
		if(!this.isValid()) {
			return;
		}
		
		this.$mdDialog.hide(this.$scope.selectedProject);
	}
	
	isValid(){
		return this.$scope.selectedProject !== null;
	}
}